"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkExperimentOverrides = checkExperimentOverrides;
exports.checkExperimentOverrideGroups = checkExperimentOverrideGroups;

var _checks = require("../../checks");

var _copyContent = _interopRequireDefault(require("../../data/copyContent"));

var _formatErrors = _interopRequireDefault(require("../../utilities/formatErrors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
* Checks Overrides Assigned to Variants on an Experiment
* Expected GQL Shape:
*
* InsertVariantToOverridesType {
  variantId: Int!
  overrideId: Int!
}

* InsertVariantToOverrideGroupsType {
  variantId: Int!
  overrideGroupId: Int!
}
*/
function checkExperimentOverrides(input) {
  const {
    experimentOverrides: {
      missingVariant
    }
  } = _copyContent.default;
  const checks = input.reduce((accumulator, {
    overrideId,
    variantId
  }) => {
    accumulator[`override__${overrideId}`] = (0, _checks.checkInteger)(variantId, missingVariant);
    return accumulator;
  }, {});
  const errors = (0, _formatErrors.default)(checks);
  return {
    checks,
    errors
  };
}

function checkExperimentOverrideGroups(input) {
  const {
    experimentOverrides: {
      missingVariant
    }
  } = _copyContent.default;
  const checks = input.reduce((accumulator, {
    overrideGroupId,
    variantId
  }) => {
    accumulator[`group__${overrideGroupId}`] = (0, _checks.checkInteger)(variantId, missingVariant);
    return accumulator;
  }, {});
  const errors = (0, _formatErrors.default)(checks);
  return {
    checks,
    errors
  };
}